import { createSelector } from '@reduxjs/toolkit';

import { calculateMemberGeometry } from '@paragon/relative-geometry';
import { notNullish } from '@paragon/utilities';

import { RootState } from '..';
import { getCommittedComponentDesigns } from './getComponentDesignsSelectors';

// TODO: merge with Scotty's version once that's finished and move to a library

export const getMemberVertices = createSelector(
  getCommittedComponentDesigns,
  (state: RootState, componentDesignGuid: string) => componentDesignGuid,
  (componentDesigns, componentDesignGuid) => {
    const design = componentDesigns.find((component) => component.guid === componentDesignGuid);
    if (!design) return null;

    return design.component.members
      .map((member) => calculateMemberGeometry(member, design.component))
      .filter(notNullish);
  },
);
